import { render } from "./SelectingIngredientList.vue?vue&type=template&id=6393b933&scoped=true&ts=true"
import script from "./SelectingIngredientList.vue?vue&type=script&lang=ts"
export * from "./SelectingIngredientList.vue?vue&type=script&lang=ts"

import "./SelectingIngredientList.vue?vue&type=style&index=0&id=6393b933&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6393b933"]])

export default __exports__